import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Alert, Button, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';
import StarRating from './star-rating';

interface IValidation {
    surgeonCare: boolean,
    nurseCare: boolean,
    painCare: boolean,
    caretakerTreatment: boolean,
    financialBurden: boolean,
    donationCost: boolean,
    commendation: boolean,
    improvement: boolean,
    isValid: boolean
}

interface IProps {
    show: boolean,
    container: any,
    onSubmit: (surgeonCare: number, nurseCare: number, painCare: number, caretakerTreatment: number,
        financialBurden: number, donationCost: number, commendation: string, improvement: string, completedDate: string) => void,
    onCancel: () => void
}

interface IState {
    completedDate: string,
    surgeonCare: number,
    nurseCare: number,
    painCare: number,
    caretakerTreatment: number,
    financialBurden: number,
    donationCost: number,
    commendation: string,
    improvement: string,
    validation: IValidation,
    dirty: boolean
}

class PostDonation30DaysSurvey extends React.Component<IProps, IState> {
    readonly state: IState = {
        completedDate: moment().format('MM/DD/YYYY'),
        surgeonCare: 0,
        nurseCare: 0,
        painCare: 0,
        caretakerTreatment: 0,
        financialBurden: 0,
        donationCost: 0,
        commendation: '',
        improvement: '',
        validation: {
            surgeonCare: true,
            nurseCare: true,
            painCare: true,
            caretakerTreatment: true,
            financialBurden: true,
            donationCost: true,
            commendation: true,
            improvement: true,
            isValid: true
        },
        dirty: false
    }

    componentWillReceiveProps = (nextProps: IProps) => {
        if (nextProps.show) {
            this.setState({
                completedDate: moment().format('MM/DD/YYYY'),
                surgeonCare: 0,
                nurseCare: 0,
                painCare: 0,
                caretakerTreatment: 0,
                financialBurden: 0,
                donationCost: 0,
                commendation: '',
                improvement: '',
                validation: {
                    surgeonCare: true,
                    nurseCare: true,
                    painCare: true,
                    caretakerTreatment: true,
                    financialBurden: true,
                    donationCost: true,
                    commendation: true,
                    improvement: true,
                    isValid: true
                },
                dirty: false
            });
        }
    }

    handleStarClick = (question: string, star: number) => {
        let validation = { ...this.state.validation };

        if (question == 'surgeonCare') {
            if (this.state.dirty) {
                validation.surgeonCare = star > 0;
                validation.isValid = this.isValid(validation);
            }

            this.setState({
                surgeonCare: star,
                validation
            });
        }

        if (question == 'nurseCare') {
            if (this.state.dirty) {
                validation.nurseCare = star > 0;
                validation.isValid = this.isValid(validation);
            }

            this.setState({
                nurseCare: star,
                validation
            });
        }

        if (question == 'painCare') {
            if (this.state.dirty) {
                validation.painCare = star > 0;
                validation.isValid = this.isValid(validation);
            }

            this.setState({
                painCare: star,
                validation
            });
        }

        if (question == 'caretakerTreatment') {
            if (this.state.dirty) {
                validation.caretakerTreatment = star > 0;
                validation.isValid = this.isValid(validation);
            }

            this.setState({
                caretakerTreatment: star,
                validation
            });
        }

        if (question == 'financialBurden') {
            if (this.state.dirty) {
                validation.financialBurden = star > 0;
                validation.isValid = this.isValid(validation);
            }

            this.setState({
                financialBurden: star,
                validation
            });
        }

        if (question == 'donationCost') {
            if (this.state.dirty) {
                validation.donationCost = star > 0;
                validation.isValid = this.isValid(validation);
            }

            this.setState({
                donationCost: star,
                validation
            });
        }
    }

    handleCommendationChange = (e: React.FormEvent<FormControl & HTMLTextAreaElement>) => {
        let validation = { ...this.state.validation };

        if (this.state.dirty) {
            validation.commendation = e.currentTarget.value != '';
            validation.isValid = this.isValid(validation);
        }

        this.setState({
            commendation: e.currentTarget.value,
            validation
        });
    }

    handleImprovementChange = (e: React.FormEvent<FormControl & HTMLTextAreaElement>) => {
        let validation = { ...this.state.validation };

        if (this.state.dirty) {
            validation.improvement = e.currentTarget.value != '';
            validation.isValid = this.isValid(validation);
        }

        this.setState({
            improvement: e.currentTarget.value,
            validation
        });
    }

    handleSubmit = () => {
        let validation = this.validate();

        this.setState({
            validation,
            dirty: true
        }, () => {
            if (this.state.validation.isValid) {
                let { surgeonCare, nurseCare, painCare, caretakerTreatment, financialBurden, donationCost, commendation, improvement, completedDate } = this.state;
                this.props.onSubmit(surgeonCare, nurseCare, painCare, caretakerTreatment, financialBurden, donationCost, commendation, improvement, completedDate);
            }
        });
    }

    validate = (): IValidation => {
        let { surgeonCare, nurseCare, painCare, caretakerTreatment, financialBurden, donationCost, commendation, improvement, completedDate } = this.state;

        let isValid =
            surgeonCare > 0
            && nurseCare > 0
            && painCare > 0
            && caretakerTreatment > 0
            && financialBurden > 0
            && donationCost > 0
            && commendation != ''
            && improvement != '';

        return {
            surgeonCare: surgeonCare > 0,
            nurseCare: nurseCare > 0,
            painCare: painCare > 0,
            caretakerTreatment: caretakerTreatment > 0,
            financialBurden: financialBurden > 0,
            donationCost: donationCost > 0,
            commendation: commendation != '',
            improvement: improvement != '',
            isValid
        };
    }

    isValid = (validation: IValidation) => {
        let { surgeonCare, nurseCare, painCare, caretakerTreatment, financialBurden, donationCost, commendation, improvement } = validation;
        let isValid = surgeonCare && nurseCare && painCare && caretakerTreatment && financialBurden && donationCost && commendation && improvement;
        return isValid;
    }

    render = () => {
        const surgeonCareInvalid = this.state.dirty && this.state.validation.surgeonCare == false;
        const nurseCareInvalid = this.state.dirty && this.state.validation.nurseCare == false;
        const painCareInvalid = this.state.dirty && this.state.validation.painCare == false;
        const caretakerTreatmentInvalid = this.state.dirty && this.state.validation.caretakerTreatment == false;
        const financialBurdenInvalid = this.state.dirty && this.state.validation.financialBurden == false;
        const donationCostInvalid = this.state.dirty && this.state.validation.donationCost == false;

        return (
            <>
                <Modal backdrop='static' show={this.props.show} onHide={this.props.onCancel} container={this.props.container}>
                    <Modal.Header closeButton>
                        <Modal.Title>30 Days Post-Surgery Final Survey</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {this.state.dirty && this.state.validation.isValid == false && (
                            <Alert bsStyle='danger' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>
                                The items in red are required
                            </Alert>
                        )}

                        <div style={{ marginBottom: 10 }}>
                            On a scale of 1-5 (1 being the lowest score and 5 being the highest (best) score), please ask the donor to rate the following aspects of their donation experience...
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <StarRating
                                numberOfStars={5}
                                currentRating={this.state.surgeonCare}
                                onClick={(rating) => this.handleStarClick('surgeonCare', rating)}
                            />

                            <div style={{ marginLeft: 20, color: surgeonCareInvalid ? '#a94442' : '', fontWeight: surgeonCareInvalid ? 700 : 400 }}>How well were they cared for by their surgeon?</div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <StarRating
                                numberOfStars={5}
                                currentRating={this.state.nurseCare}
                                onClick={(rating) => this.handleStarClick('nurseCare', rating)}
                            />

                            <div style={{ marginLeft: 20, color: nurseCareInvalid ? '#a94442' : '', fontWeight: nurseCareInvalid ? 700 : 400 }}>How well were they cared for by the nursing staff?</div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <StarRating
                                numberOfStars={5}
                                currentRating={this.state.painCare}
                                onClick={(rating) => this.handleStarClick('painCare', rating)}
                            />

                            <div style={{ marginLeft: 20, color: painCareInvalid ? '#a94442' : '', fontWeight: painCareInvalid ? 700 : 400 }}>How would they rate their pain management?</div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <StarRating
                                numberOfStars={5}
                                currentRating={this.state.caretakerTreatment}
                                onClick={(rating) => this.handleStarClick('caretakerTreatment', rating)}
                            />

                            <div style={{ marginLeft: 20, color: caretakerTreatmentInvalid ? '#a94442' : '', fontWeight: caretakerTreatmentInvalid ? 700 : 400 }}>How well was their caretaker treated?</div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
                            <StarRating
                                numberOfStars={5}
                                currentRating={this.state.financialBurden}
                                onClick={(rating) => this.handleStarClick('financialBurden', rating)}
                            />

                            <div style={{ marginLeft: 20, color: financialBurdenInvalid ? '#a94442' : '', fontWeight: financialBurdenInvalid ? 700 : 400 }}>Please rate the financial burden of organ donation; 1 being no burden, and 5 being extreme burden</div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
                            <StarRating
                                numberOfStars={5}
                                currentRating={this.state.donationCost}
                                onClick={(rating) => this.handleStarClick('donationCost', rating)}
                            />

                            <div style={{ marginLeft: 20, color: donationCostInvalid ? '#a94442' : '', fontWeight: donationCostInvalid ? 700 : 400 }}>Was the cost of donation important when deciding to donate; 1 being not a factor, and 5 being required consideration</div>
                        </div>

                        <FormGroup validationState={this.state.dirty && this.state.validation.commendation == false ? 'error' : null}>
                            <ControlLabel>Was there anyone who did an especially great job taking care of them that they would like to commend?</ControlLabel>
                            <FormControl
                                componentClass='textarea'
                                style={{ height: 75, resize: 'none' }}
                                value={this.state.commendation}
                                onChange={this.handleCommendationChange}
                            />
                        </FormGroup>

                        <FormGroup validationState={this.state.dirty && this.state.validation.improvement == false ? 'error' : null}>
                            <ControlLabel>How can the transplant center improve?</ControlLabel>
                            <FormControl
                                componentClass='textarea'
                                style={{ height: 75, resize: 'none' }}
                                value={this.state.improvement}
                                onChange={this.handleImprovementChange}
                            />
                        </FormGroup>

                        <FormGroup style={{ marginBottom: 0 }}>
                            <ControlLabel>Date survey completed?</ControlLabel>
                            <div className='form-control-static'>{this.state.completedDate}</div>
                        </FormGroup>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button bsStyle='primary' onClick={this.handleSubmit}>Submit</Button>
                        <Button onClick={this.props.onCancel}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default PostDonation30DaysSurvey;